var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillCheckClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified_user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.666667L2 3.33333V7.33333C2 11.0333 4.56 14.4933 8 15.3333C11.44 14.4933 14 11.0333 14 7.33333V3.33333L8 0.666667ZM12.6667 7.33333C12.6667 10.3467 10.68 13.1267 8 13.9533C5.32 13.1267 3.33333 10.3467 3.33333 7.33333V4.2L8 2.12667L12.6667 4.2V7.33333ZM4.94 7.72667L4 8.66667L6.66667 11.3333L12 6L11.06 5.05333L6.66667 9.44667L4.94 7.72667Z",
    fill: "#8C15FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillCheckClaim);
export default __webpack_public_path__ + "static/media/pill_check_claim.e53ccd9d2437ce01776d8c6af103d082.svg";
export { ForwardRef as ReactComponent };